<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My course doesn’t have a book</h1>

			<h3>Please select your course first</h3>

			<search-course @selected="courseSelected"></search-course>

			<v-flex xs12 v-if="selected_course" class="h-selected-course">
				<v-card color="" class="">
					<v-layout>
						<v-flex xs12>
							<v-card-title primary-title>
								<div>
									<div class="headline mb-3">Selected Course</div>
									<div><strong>Name: </strong>{{ selected_course['name'] }} ({{ selected_course['code'] }}<span v-if="selected_course['section']"> {{ selected_course['section'] }}</span>)</div>
									<div v-if="selected_course['user_name']"><strong>Professor: </strong>{{ selected_course['user_name'] }}</div>
								</div>
							</v-card-title>
						</v-flex>
					</v-layout>
					<v-divider light></v-divider>
				</v-card>
			</v-flex>

			<v-base-nav-page :links="links" :nosearch="true" v-if="selected_course">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './../../components/BaseNavPage';
	import BaseNavLinks from './../../components/BaseNavLinks';
	import SearchCourse from './../../components/SearchCourse';

	export default {
		name: "CourseDoesntHaveBook",

		components: {
			BaseNavLinks,
			SearchCourse,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			return {
				selected_course: null,

				links: [
					{
						click: this.addCourseId('/there_is_book_got_isbn/'),
						caption: 'My teacher said there’s a book and I have the ISBN'
					},
					{
						click: this.addCourseId('/there_is_book_got_title/'),
						caption: 'My teacher said there’s a book and I have the title'
					},
					{
						click: this.addCourseId('/there_is_book_got_no_isbn/'),
						caption: 'My teacher said there’s a book but I don’t know what it’s called or the ISBN'
					},
					{
						click: this.addCourseId('/supposed_to_be_book/'),
						caption: 'I think there’s supposed to be a book but I’m not sure'
					},
				]
			}
		},

		mounted() {
			const self = this;
		},

		methods: {
			courseSelected(val) {
				if (!val || !val['course_ids']) return;
				this.selected_course = val;
			},

			addCourseId(prefix) {
				const self = this;
				return function () {
					self.$router.push(prefix + self.selected_course['course_ids']);
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.h-selected-course {
		margin: 0 0 30px;
	}
</style>